import NewTextInput from '@/core/components/inputs/TextInput/NewTextInput';
import SearchInput from '@/core/components/inputs/TextInput/SearchInput';
import TextInput from '@/core/components/inputs/TextInput/TextInput';

export { NewTextInput, SearchInput };
export default TextInput;
